<label
  [ngClass]="{ disabled: disabled }"
  class="common-checkbox mb-0 {{customClass}}"
  [attr.aria-label]="ariaLabel || label">
  <input
    #checkboxInput
    [id]="id"
    [name]="name"
    [disabled]="disabled"
    [checked]="checked"
    (click)="onCheckboxClick($event)"
    (change)="onCheckboxChange($event)"
    (keydown.enter)="onKeyDown($event)"
    (keydown.space)="onKeyDown($event)"
    class="d-none"
    type="checkbox"/>
  <img
    [ngSrc]="getCheckboxIcon()"
    alt="checkbox"
    width="20"
    height="20"
    class="common-checkbox__img"
    [class.common-checkbox__img--partial]="indeterminate"
    [style.opacity]="disabled ? '0.5' : '1'"
  />
</label>
